import { render, staticRenderFns } from "./goveCommunication.vue?vue&type=template&id=5876c9f2&scoped=true"
import script from "./goveCommunication.vue?vue&type=script&lang=js"
export * from "./goveCommunication.vue?vue&type=script&lang=js"
import style0 from "./goveCommunication.vue?vue&type=style&index=0&id=5876c9f2&prod&lang=less&scoped=true"
import style1 from "./goveCommunication.vue?vue&type=style&index=1&id=5876c9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876c9f2",
  null
  
)

export default component.exports